import {REPORT_RANK_UP} from '/enum/records.enum';

export default {
  reportName: REPORT_RANK_UP,
};
